enum ConservationState {
  Good = "good",
  Fair = "fair",
  Poor = "poor",
  Very_bad = "very bad",
}

export default ConservationState;
